export default {
      id: "icon--calendar-blue-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--calendar-blue-usage",
      toString: function () {
        return this.url;
      }
    }